module.exports = __webpack_public_path__ + "img/wallet-blue.f0bc767f.svg";